<template>
    <glass-panel
        radius="lg"
        class="empty-state"
    >
        <div
            v-if="icon"
            class="empty-state__icon-wrap"
        >
            <v-icon
                size="42"
                color="primary"
            >
                {{ icon }}
            </v-icon>
        </div>

        <h2
            v-if="title || $slots.title"
            class="empty-state__title"
        >
            <slot name="title">{{ title }}</slot>
        </h2>

        <p
            v-if="description || $slots.default"
            class="empty-state__desc"
        >
            <slot>{{ description }}</slot>
        </p>

        <div
            v-if="$slots.actions"
            class="empty-state__actions"
        >
            <slot name="actions" />
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'EmptyState',
    props: {
        icon: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 56px 32px;
    max-width: 560px;
    margin: 32px auto;
}

.empty-state__icon-wrap {
    width: 80px;
    height: 80px;
    border-radius: 9999px;
    background: rgba(112, 42, 225, 0.1);
    border: 1px solid rgba(112, 42, 225, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    box-shadow: var(--shadow-pulse);
}

.empty-state__title {
    font-family: var(--font-display);
    font-weight: 800;
    font-size: 1.5rem;
    letter-spacing: -0.01em;
    color: var(--color-on-surface);
    margin: 0 0 8px;
}

.empty-state__desc {
    font-family: var(--font-body);
    font-size: 0.875rem;
    line-height: 1.6;
    color: var(--color-on-surface-variant);
    margin: 0 0 24px;
    max-width: 420px;
}

.empty-state__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    margin-top: 8px;
}
</style>
